import { unloadVideo } from '$helper/functions/unload-video';
import type { RefObject } from 'react';
import { useEffect } from 'react';



// Fix for memory leak when unmounting video element
export default function useVideoCleanup(videoRef: RefObject<HTMLVideoElement>, dependencies: any[]) {
  useEffect(() => {
    const videoEl = videoRef.current;

    return () => {
      if (videoEl) {
        // It may be slow (specifically on iOS), so we postpone it after unmounting
        unloadVideo(videoEl);
      }
    };
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, dependencies);
}
